import React, { FC } from 'react';

interface FeedbackDialogProps {
  open: boolean;
  onClose: () => void;
  fromPublic?: boolean;
}

const OkdeskForm: FC<FeedbackDialogProps> = ({ open, onClose }) => {
  setTimeout(() => {
    if (open) onClose();
  }, 500);

  const showOkdeskForm = () => {
    const scriptId = 'okdesk-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.innerHTML = `
        WebFormSettings = {
          btn_text: 'Оставить заявку',
          btn_text_color: '#FFFFFF',
          btn_color: '#4dad33',
          btn_border_color: '#FFFFFF',
        //   btn_position: 'bottom',
          account_name: 'tatar',
          site_url: 'https://tatar.okdesk.ru/'
        };

        var scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.charset = 'utf-8';
        scriptTag.src = 'https://tatar.okdesk.ru/web-form/web-form.js';
        document.body.appendChild(scriptTag);

        // Автоматически нажимаем кнопку с классом "okdesk_widget_open"
        setTimeout(function() {
          const button = document.querySelector('.okdesk_widget_open');
          document.querySelector('.okdesk_popup')?.setAttribute('style', 'z-index: 1200');
          if (button) {
            button.click();
            document.querySelector('.okdesk_popup')?.setAttribute('style', 'z-index: 1200');
          }
        }, 500); // Задержка на 1 секунду для уверенности, что кнопка появилась
      `;

      document.body.appendChild(script);
    } else {
      const button = document.querySelector('.okdesk_widget_open');
      document.querySelector('.okdesk_popup')?.setAttribute('style', 'z-index: 1200');
      if (button instanceof HTMLElement && button) {
        button.click();
        document.querySelector('.okdesk_popup')?.setAttribute('style', 'z-index: 1200');
      }
    }
  };

  return <>{open && showOkdeskForm()}</>;
};

export default OkdeskForm;
